export default "__VITE_ASSET__fd6c0398__"